import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { BroadcastService } from "src/app/services/core/broadcast/broadcast.service";
import { ToasterService } from "../../../services/shared/toaster/toaster.service";
import { IBroadcast, IBroadcastBotInfo } from "src/app/models/broadcast";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { COMMA, ENTER } from "@angular/cdk/keycodes";

@Component({
  selector: "app-addbroadcast",
  templateUrl: "./addbroadcast.component.html",
  styleUrls: ["./addbroadcast.component.scss"],
})
export class AddbroadcastComponent implements OnInit {
  @ViewChild("closebutton", { static: true }) SaveButton: ElementRef;
  addNewBroadcast: boolean;
  broadcastDetails: any;
  broadcastId: number;
  dayList: any[] = [];

  //Form Corntrolls
  newBroadcastForm: FormGroup;
  BotName: FormControl;
  BroadcastName: FormControl;
  Description: FormControl;
  Recipients: FormControl;
  TriggerMode: FormControl;
  QnaQuestion: FormControl;
  ScheduleDate: FormControl;
  ScheduleTime: FormControl;
  RecurWeekDay: FormControl;
  RecurWeekDayTime: FormControl;
  RecurMonthDay: FormControl;
  RecurMonthDayTime: FormControl;
  RecipientOption: FormControl;
  //-------------------------------
  private _subscriptions = new Subscription();
  userRoles: string[] = [];
  selectedUserId: string;
  botList: any;
  broadcastBotInfo: IBroadcastBotInfo;
  broadcastData: IBroadcast;
  SelectedBotName: string;
  superAdmin: boolean;
  botConfigId: number;
  notifyRequest: IBroadcast;
  broadcastList: IBroadcast[] = [];
  hasError: boolean = false;
  isSchedule: boolean = false;
  isRecWeekly: boolean = false;
  isRecMonthly: boolean = false;
  isSelect: boolean = false;
  selectedDay: string;
  selectedDate: string;
  selectedTrigger: string;
  isEdit: boolean = false;
  lastDay: string;
  today: string;

  selectable = true;
  removable = true;
  recipientList: string[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  recipientCtrl = new FormControl();
  filteredRecipients: Observable<string[]>;
  selectedRecipients: string[] = [];
  @ViewChild("recipientInput", { static: false })
  recipientInput: ElementRef<HTMLInputElement>;
  constructor(
    private toasterService: ToasterService,
    private broadcastService: BroadcastService,
    private router: Router //private datePipe: DatePipe
  ) {
    this.filteredRecipients = this.recipientCtrl.valueChanges.pipe(
      startWith(null),
      map((rec: string | null) =>
        rec ? this._filter(rec) : this.recipientList.slice()
      )
    );
  }
  ngOnInit() {
    this.CreateDayList();
    this.SetCurrentDate();
    this.broadcastBotInfo = JSON.parse(
      sessionStorage.getItem("broadcastBotInfo")
    );
    this.broadcastData = JSON.parse(sessionStorage.getItem("broadcastData"));
    if (this.broadcastData) {
      this.isEdit = true;
      if (this.broadcastData.scheduleDate) {
        let date = this.broadcastData.scheduleDate.split("T")[0];
        this.broadcastData.scheduleDate = date;
      }
    }
    if (!this.broadcastBotInfo && !this.isEdit) {
      this.toasterService.error(
        "You are not authorized to create broadcast for this BOT!"
      );
      this.router.navigate(["utility/broadcast"]);
    }

    this.userRoles = sessionStorage.getItem("userRoles")
      ? sessionStorage.getItem("userRoles").split(",")
      : [];
    let superAdminUser = this.userRoles.find(
      (ob) =>
        ob.toLowerCase() === "superadmin" || ob.toLowerCase() === "super admin"
    );
    if (superAdminUser) {
      this.superAdmin = true;
    }
    this.hasError = false;
    this.BotName = new FormControl(
      { value: this.broadcastBotInfo.displayName, disabled: true },
      Validators.required
    );
    if (this.isEdit) {
      this.broadcastId = this.broadcastData.id;
      this.onTriggerChange(this.broadcastData.triggerMode);
      this.BroadcastName = new FormControl(
        this.broadcastData.name,
        Validators.compose([Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+')])
      );
      this.Description = new FormControl(
        this.broadcastData.description,
        Validators.compose([Validators.required, Validators.pattern(/^[-_ a-zA-Z0-9]+$/)])
      );
      this.Recipients = new FormControl();
      this.RecipientOption = new FormControl();
      this.selectedRecipients = this.broadcastData.recipients.split(",");
      this.TriggerMode = new FormControl(
        this.broadcastData.triggerMode,
        Validators.required
      );
      this.ScheduleDate = new FormControl(this.broadcastData.scheduleDate);
      this.ScheduleTime = new FormControl(this.broadcastData.scheduleTime);
      this.RecurWeekDay = new FormControl(this.broadcastData.recurWeekDay);
      this.RecurWeekDayTime = new FormControl(
        this.broadcastData.recurWeekDayTime
      );
      this.RecurMonthDay = new FormControl(this.broadcastData.recurMonthDay);
      this.RecurMonthDayTime = new FormControl(
        this.broadcastData.recurMonthDayTime
      );
      this.QnaQuestion = new FormControl(
        this.broadcastData.qnaQuestion,
        Validators.required
      );
    } else {
      this.broadcastId = 0;
      this.BroadcastName = new FormControl("", Validators.compose([Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+')]));
      this.Description = new FormControl("", Validators.compose([Validators.required, Validators.pattern(/^[-_ a-zA-Z0-9]+$/)]));
      this.Recipients = new FormControl("");
      this.TriggerMode = new FormControl("Manual", Validators.required);
      this.ScheduleDate = new FormControl(this.today);
      this.ScheduleTime = new FormControl("12:00");
      this.RecurWeekDay = new FormControl("0");
      this.RecurWeekDayTime = new FormControl("12:00");
      this.RecurMonthDay = new FormControl("1");
      this.RecurMonthDayTime = new FormControl("12:00");
      this.QnaQuestion = new FormControl("", Validators.required);
      this.RecipientOption = new FormControl("all");
    }

    this.newBroadcastForm = new FormGroup({
      BotName: this.BotName,
      BroadcastName: this.BroadcastName,
      Description: this.Description,
      Recipients: this.Recipients,
      TriggerMode: this.TriggerMode,
      ScheduleDate: this.ScheduleDate,
      ScheduleTime: this.ScheduleTime,
      RecurWeekDay: this.RecurWeekDay,
      RecurWeekDayTime: this.RecurWeekDayTime,
      RecurMonthDay: this.RecurMonthDay,
      RecurMonthDayTime: this.RecurMonthDayTime,
      QnaQuestion: this.QnaQuestion,
    });
    this.GetAllBotAccessedUsers();
  }
  onTriggerChange(value) {
    switch (value) {
      case "Manual": {
        this.isSchedule = false;
        this.isRecWeekly = false;
        this.isRecMonthly = false;
        break;
      }
      case "Scheduled": {
        this.isSchedule = true;
        this.isRecWeekly = false;
        this.isRecMonthly = false;
        break;
      }
      case "Rec-Weekly": {
        this.isSchedule = false;
        this.isRecWeekly = true;
        this.isRecMonthly = false;
        break;
      }
      case "Rec-Monthly": {
        this.isSchedule = false;
        this.isRecWeekly = false;
        this.isRecMonthly = true;
        break;
      }
    }
  }
  BroadcastCancel() {
    this.router.navigate(["utility/broadcast"], {
      queryParams: { id: this.broadcastBotInfo.botConfigId },
    });
  }
  onSelectionChanged(selectedUser) {
    this.selectedUserId = selectedUser;
  }
  BroadcastSave(formValues) {
    this.broadcastDetails = {
      Id: this.broadcastId,
      BotConfigId: this.broadcastBotInfo.botConfigId,
      Name: formValues.BroadcastName,
      Description: formValues.Description,
      Recipients: this.selectedRecipients.join(","),
      TriggerMode: formValues.TriggerMode,
      QnaQuestion: formValues.QnaQuestion,
      ScheduleDate: formValues.ScheduleDate,
      ScheduleTime: formValues.ScheduleTime,
      RecurWeekDay: formValues.RecurWeekDay,
      RecurWeekDayTime: formValues.RecurWeekDayTime,
      RecurMonthDay: formValues.RecurMonthDay,
      RecurMonthDayTime: formValues.RecurMonthDayTime,
    };
    this._subscriptions.add(
      this.broadcastService.CreateBroadcast(this.broadcastDetails).subscribe(
        (res) => {
          this.toasterService.success("Broadcast created successfully!!");
          this.newBroadcastForm.reset();
          this.router.navigate(["utility/broadcast"], {
            queryParams: { id: this.broadcastBotInfo.botConfigId },
          });
        },
        (error) => {
          this.addNewBroadcast = false;
        }
      )
    );
  }
  SetCurrentDate() {
    let dte = new Date();
 
    let month =
      dte.getMonth() > 9
        ? (dte.getMonth() + 1).toString()
        : "0" + (dte.getMonth()+1).toString();
      let day =
      dte.getDate() > 9
        ? dte.getDate().toString()
        : "0" + dte.getDate().toString();
    this.today = dte.getFullYear().toString() + "-" + month + "-" + day;
   
  }

  CreateDayList() {
    let dateText: string;
    let date: any;
    for (let i = 1; i <= 31; i++) {
      switch (i % 10) {
        case 1:
          dateText=(i==11)?i + "th day":i + "st day"
          break;
        case 2:
          dateText=(i==12)?i + "th day":i + "nd day"
          break;
        case 3:
          dateText=(i==13)?i + "th day":i + "rd day"
          break;
        default:
          dateText = i + "th day";
          break;
      }
      date = {
        dateNo: i,
        text: dateText,
      };
      this.dayList.push(date);
    }
  }
  GetAllBotAccessedUsers() {
    this._subscriptions.add(
      this.broadcastService
        .GetAllBotAccessedUsers(this.broadcastBotInfo.botConfigId)
        .subscribe(
          (res) => {
            this.recipientList = res;
               },
          (error) => {
            console.log(error);
          }
        )
    );
  }
  add(event: MatChipInputEvent): void {
    const value = (event.value || "").trim();

    // Add our Recipients
    if (value) {
      this.selectedRecipients.push(value);
    }

    // Clear the input value
    //event.chipInput!.clear();
    if (event.input) {
      event.input.value = "";
    }

    this.recipientCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.selectedRecipients.indexOf(fruit);

    if (index >= 0) {
      this.selectedRecipients.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedRecipients.push(event.option.viewValue);
    this.recipientInput.nativeElement.value = "";
    this.recipientCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.recipientList.filter((recipientsit) =>
      recipientsit.toLowerCase().includes(filterValue)
    );
  }
  ChangeRecipientOption(event) {
    if(event.target.value != "select")
    {
      this.selectedRecipients=this.recipientList;
    } 
    else
    {
      this.selectedRecipients=[];
    }
  }
  //---------------------------------------
}
